<div class="dasboard-width font-13">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="row header mar-lft-rgt-0" style="padding-bottom: 0px;">
        <div class="col-sm-4">Create Ticket</div>
        <!--<div class="col-sm-2" [hidden]="!isAnalyst"><select class="custom-select  tcktyp"
                                      (change)="onRoleChange($event.target.value)">
          <option *ngFor="let r of role" [value]="r.type">{{r.name}}</option>
        </select></div>-->
        <div class="col-sm-4">
            <mat-form-field>
                <mat-label>Current Role:</mat-label>
                <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()">
                    <mat-option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <ol class="breadcrumb cust-bread">
                <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i class="fa fa-dashboard"></i>
                        Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Create Ticket</li>
            </ol>
        </div>
    </div>
    <div class="content mr-top-5 ">
        <div class="row mar-lft-rgt-0 font-16">
            <div class="col-sm-12 pad-15">
                <div class="height-40" [hidden]="ticketTypeLoaded">
                    <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                </div>
                <mat-radio-group (change)="onButtonChange($event)" [hidden]="!ticketTypeLoaded">
                    <!--<div *ngFor="let button of radioButton;">-->
                    <mat-radio-button *ngFor="let button of radioButton;" [value]="button" [checked]="button.checked">
                        {{button.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </mat-radio-button>&nbsp;&nbsp;
                    <!--</div>-->
                </mat-radio-group>
            </div>
        </div>

        <app-create-ticket-jusco-cr *ngIf="hideCr" [radioChecked]="radioChecked" [clientId]="clientId"
            [parrentTicketId]="parrentTicketId" [displayed]="displayed" [typeSeq]="typeSeq" [userName]="userName"
            [wfcresultId]="wfcresultId" (ticketLoader)="showDataLoader($event)"></app-create-ticket-jusco-cr>
        <app-create-ticket-pr *ngIf="hidePr" [radioChecked]="radioChecked" [clientId]="clientId"
            [parrentTicketId]="parrentTicketId" [displayed]="displayed" [typeSeq]="typeSeq" [userName]="userName"
            [wfcresultId]="wfcresultId" (ticketLoader)="showDataLoader($event)"></app-create-ticket-pr>
        <div *ngIf="!hideCr && !hidePr">
            <div class="row mar-lft-rgt-0 font-16" [hidden]="!subRadioDisplay">
                <div class="col-sm-12 pad-15">
                    <mat-radio-group (change)="onSubButtonChange($event)">
                        <mat-radio-button *ngFor="let button of subtypes;" [value]="button" [checked]="button.checked">
                            {{button.type}}
                        </mat-radio-button>&nbsp;&nbsp;
                    </mat-radio-group>
                </div>
            </div>
            <div class="row mar-lft-rgt-0">
                <div class="col-md-12 pad-15">
                    <div class="height-40" [hidden]="categoryLoaded">
                        <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                    </div>
                    <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                        [disabled]="ticket.isDisabled" (click)="categoryClick(ticket,$event.target.value)"
                        (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                        [hidden]="!categoryLoaded">
                        <option *ngFor="let option of ticket.options" id="ticketoption_{{option.id}}"
                            [value]="option|json">{{option.title}}</option>
                    </select>

                </div>
            </div>

            <div class="row mar-lft-rgt-0">
                <div style=" margin-left: 15px;">
                    <select class="custom-select  tcktyp" [(ngModel)]="custome_parent_child_attr_Hedder_id"
                        (change)="custome_parent_child_attr_byId('value', custome_parent_child_attr_Hedder_id)"
                        [disabled]="selectVal1">
                        <option *ngFor="let option of custome_parent_child_attr_Hedder" [value]="option.id">
                            {{option.attribute}}</option>
                    </select>
                </div>

                <div style=" margin-left: 15px;" *ngIf="custome_parent_child_attr_value.length > 0">
                    <select class="custom-select  tcktyp" [(ngModel)]="custome_parent_child_attr_value_id"
                        (change)="onChange1($event.target.selectedIndex)">
                        <option *ngFor="let option of custome_parent_child_attr_value" [value]="option.id">
                            {{option.attribute}}</option>
                    </select>
                </div>

            </div>

            <div class="mar-lft-rgt-0">
                <div class="row" style=" margin-left: 15px;">

                    <div class="margin" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
                        <input [ngClass]="field.isQuestion? ' ' : 'col-sm-12'" *ngSwitchCase="'1'"
                            [hidden]="field.isQuestion" type="text" class="form-control radius-0 font-13 marginTop"
                            placeholder="{{field.fieldName}}" [(ngModel)]="field.value">
                        <mat-form-field *ngSwitchCase="'4'" class="col-sm-2 matcss">
                            <mat-label>{{field.fieldName}}</mat-label>
                            <mat-select [(ngModel)]="field.value">
                                <mat-option *ngFor="let opt of field.values" [value]="opt">{{opt}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="form-group  marginTop" *ngSwitchCase="'1'" [hidden]="!field.isQuestion">
                            <div class="row margin2">

                                <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <input type="text" class="form-control radius-0 font-13 "
                                            [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)"
                                            maxlength="200" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="form-group  marginTop" *ngSwitchCase="'7'" [hidden]="!field.isQuestion">
                            <div class="row margin2">

                                <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <textarea class="form-control radius-0 font-13 heighttxt"
                                            [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)"
                                            maxlength="200"></textarea>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="form-group" *ngSwitchCase="'2'">
                            <div class="row margin2 date-type">
                                <div class="form-group">
                                    <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                        placeholder="{{field.fieldName}}" [(ngModel)]="field.value"
                                        [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [min]="min">
                                    <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
                                </div>
                            </div>
                        </div>
                        <div class="form-group " *ngSwitchCase="'5'">
                            <div class="row margin2 date-type">
                                <div class="form-group">
                                    <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                        placeholder="{{field.fieldName}}" [(ngModel)]="field.value"
                                        [owlDateTimeTrigger]="dt" [owlDateTime]="dt">
                                    <owl-date-time [pickerType]="'timer'" #dt></owl-date-time>
                                </div>
                            </div>
                        </div>
                        <div class="form-group " *ngSwitchCase="'6'">
                            <div class="row margin2 date-type">
                                <div class="form-group">
                                    <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                        placeholder="{{field.fieldName}}" [(ngModel)]="field.value"
                                        [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [min]="min">
                                    <owl-date-time #dt></owl-date-time>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mar-lft-rgt-0 row">
                <div class="form-group col-md-4 mar-top-9" *ngFor="let field of approverDetails;">
                    <mat-title><b>{{field.roleName}}</b></mat-title>
                    <input class="form-control radius-0 font-13 marginTop" [(ngModel)]="field.name" readonly>
                </div>


            </div>


            <div class=" mar-lft-rgt-0" [hidden]="!reactiveSearchDisplay">
                <div class="row" style=" margin-left: 15px;">

                    <div class="row margin2 date-type">
                        <div class="form-group">
                            <input class="form-control radius-0 font-13 marginTop widthBox"
                                placeholder="Schedule Start Date" [(ngModel)]="scheduleStartDate" readonly
                                [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [min]="min"
                                [ngClass]="isBlankscheduler?'error-field':''">
                            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                        </div>
                    </div>

                    <div class="row margin2 date-type">
                        <div class="form-group">
                            <input class="form-control radius-0 font-13 marginTop widthBox"
                                placeholder="Schedule Duration(in min)" [(ngModel)]="scheduleDuration" type="number"
                                min="0" [ngClass]="isBlankscheduler?'error-field':''">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="row margin2 date-type">
                            <div class="form-group">
                                <input class="form-control radius-0 font-13 marginTop widthBox"
                                    placeholder="Planned Activity Start Date/Time" readonly [(ngModel)]="plannedStartDt"
                                    [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [min]="min"
                                    [ngClass]="isBlankscheduler?'error-field':''">

                                <owl-date-time #dt1></owl-date-time>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="row margin2 date-type">
                            <div class="form-group">
                                <input class="form-control radius-0 font-13 marginTop widthBox"
                                    placeholder="Planned Activity End Date/Time" readonly [(ngModel)]="plannedEndDt"
                                    [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [min]="min"
                                    [ngClass]="isBlankscheduler?'error-field':''">
                                <owl-date-time #dt2></owl-date-time>
                            </div>
                        </div>
                    </div>

                    <div class="row margin2 date-type">
                        <div class="form-group">
                            <button type="button" (click)="checkConflicket()"
                                class="btn btn-primary radius-0 font-13 marginTop "
                                [ngClass]="isBlankscheduler?'error-field':''">
                                Check conflict
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mar-lft-rgt-0 configTable" [hidden]="!plannedTicketDisplay">
                    <div class="col-md-12 search-box">
                        <table class="table">
                            <thead class="thead-light">
                                <tr class="rsdb-head">
                                    <th>Sl No</th>
                                    <th>Ticket_id</th>
                                    <th>Status</th>
                                    <th>Planned Activity Start Date/Time</th>
                                    <th>Planned Activity End Date/Time</th>
                                    <th>Schedule Start Date</th>
                                    <th>Schedule Duration</th>

                                </tr>
                            </thead>
                            <tbody class="rsdb-body">
                                <tr *ngFor="let plannedTicketArrs of plannedTicketArr;let i = index;">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{plannedTicketArrs.ticket_id}}</td>
                                    <td>{{plannedTicketArrs.status}}</td>
                                    <td>{{plannedTicketArrs.planned_activity_start_dt}}</td>
                                    <td>{{plannedTicketArrs.planned_activity_end_dt}}</td>
                                    <td>{{plannedTicketArrs.schedule_start_date}}</td>
                                    <td>{{plannedTicketArrs.schedule_duration}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <div class="row mar-lft-rgt-0">

                <div class="col-md-7 ">
                    <div class="row mar-lft-rgt-0">
                        <div class="col-md-8 search-box" [hidden]="!displayed">
                            <mat-form-field class="example-chip-list">
                                <mat-chip-list #chipList>
                                    <mat-chip color="primary" selected *ngFor="let ticket of Tickets"
                                        [selectable]="selectable" [removable]="removable" (removed)="remove(ticket)">
                                        {{ticket}}
                                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip>
                                    <input placeholder="Search" [matChipInputFor]="chipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        [matChipInputAddOnBlur]="addOnBlur">
                                </mat-chip-list>
                            </mat-form-field>

                        </div>
                        <div class="col-md-4" style="float: right" [hidden]="!displayed">
                            <button type="button" class="btn btn-success radius-0 font-13" (click)="openModal(content)">
                                Attach
                                CI
                            </button>
                        </div>
                    </div>
                    <!--=========================== reactive problem search ==============================================-->

                    <div class="row mar-lft-rgt-0">
                        <div class="col-md-8 search-box" [hidden]="!reactiveSearchDisplay">
                            <mat-chip-list #chipList>
                                <mat-chip color="primary" selected *ngFor="let data of addedTicket"
                                    [selectable]="selectable" [removable]="removable"
                                    (removed)="removeReactiveProblemData(data)">
                                    {{data}}
                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                </mat-chip>
                                <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur">
                            </mat-chip-list>
                        </div>
                        <div class="col-md-4" style="float: right" [hidden]="!reactiveSearchDisplay">
                            <button type="button" class="btn btn-success radius-0 font-13"
                                (click)="ticketModal(contentData)">
                                Attach
                                Ticket
                            </button>
                        </div>
                    </div>
                    <div class="row mar-top-9">
                        <div class="form-group col-md-6">
                            <mat-title><b>Requester Info:</b></mat-title>
                            <input type="text" class="form-control radius-0 font-13 "
                                placeholder="Enter Requester info (Ex. Name, phone number , email etc)"
                                [(ngModel)]="name" title="{{name}}" readonly
                                [ngClass]="isBlankRequester?'error-field':''">
                        </div>
                        <!-- [hidden]="isLowestLevel" -->
                        <div class="form-group col-md-6 row mar-lft-rgt-0" [hidden]="isLowestLevel"
                            *ngIf="priorityType === 2">
                            <p class="col-sm-2 custom-label pad-lft-0">Priority</p>
                            <div class="col-sm-10">
                                <input class="form-control radius-0 font-13 " type="text" [(ngModel)]="priority"
                                    placeholder="Priority" readonly [ngClass]="isBlankPriority?'error-field':''">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="typeSeq === 1">
                        <div class="form-group col-md-6 mar-top-9">
                            <mat-title><b>Fire Fighter Access Required ?</b></mat-title>
                            <div class="warning-msg">
                                If Fire Fighter Access Required Is Yes
                            </div>
                            <select class="custom-select mr-sm-2 radius-0 font-13 mar-top-9"
                                [(ngModel)]="fireFighterAccessValue"
                                (change)="onfireFighterAccessValueChange(fireFighterAccessValue)">
                                <option *ngFor="let master of listoffireFighterAccess" [value]="master.name">
                                    {{master.name}}</option>
                            </select>
                            
                        </div>

                        <div class="form-group col-md-6 mar-top-9">
                            <mat-title><b>FI Approval Required ?</b></mat-title>
                            <div class="warning-msg">
                                If FI Approval Required Is Yes
                            </div>
                            <select class="custom-select mr-sm-2 radius-0 font-13 mar-top-9"
                                [(ngModel)]="FIApprovalValue">
                                <option *ngFor="let master of listoffireFighterAccess" [value]="master.name">
                                    {{master.name}}</option>
                            </select>
                        </div>

                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control radius-0 font-13" placeholder="Title" [(ngModel)]="desc"
                            maxlength="50" [ngClass]="isBlankDesc?'error-field':''">
                        <div class="warning-msg">
                            *maximum 50 characters
                        </div>
                    </div>
                    <div class="form-group">
                        <textarea class="form-control radius-0 font-13 edge-textarea brief-desc"
                            placeholder="Brief description" [(ngModel)]="brief" maxlength="1000"
                            [ngClass]="isBlankLong?'error-field':''" mwlResizable [enableGhostResize]="false"
                            resizeCursorPrecision="100"
                            [resizeEdges]="{bottom: true, right: false, top: false, left: false}"
                            (resizeEnd)="onResizeEnd($event)" [style.height.px]="height"></textarea>
                        <div class="warning-msg">
                            *maximum 1000 characters
                        </div>
                    </div>
                    <div class="form-group" [hidden]="hideClaim">
                        <input type="text" class="form-control radius-0 font-13" placeholder="Enter Claim No"
                            [(ngModel)]="claimNo" [ngClass]="isBlankClaim?'error-field':''">
                    </div>
                </div>
                <div class="col-md-5" [hidden]=" !(typeSeq == 1 || typeSeq == 27)">
                    <mat-tab-group #tab class="tabset" [selectedIndex]="selectedTab">
                        <mat-tab label="Recent Tickets" id="tab1">
                            <div class="card">
                                <div class="card-body card-body-grid" style="height:237px;overflow: auto;padding:3px;">
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="rsdb-head">
                                                <th>Ticket Id</th>
                                                <th>Title</th>
                                                <!--                                        <th>Desc</th>-->
                                                <th>Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody class="rsdb-body">
                                            <tr *ngFor="let rsdb of rsdbData" (click)="clickRsdb(rsdb.id)">
                                                <td>{{rsdb.ticket_id}}</td>
                                                <td>{{rsdb.tName}}</td>
                                                <!--                                        <td>{{rsdb.longDesc}}</td>-->
                                                <td>{{rsdb.ticket_status}}</td>
                                                <td>{{rsdb.createdate | date:'medium'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab label="Knowledge Map" id="tab2">
                            <div class="card">
                                <div class="card-body card-body-grid cardbody"
                                    style="height:237px;overflow: auto;padding:3px;">
                                    <mat-accordion>
                                        <mat-expansion-panel id="search_panel_{{data.id}}"
                                            *ngFor="let data of searchDtls" (opened)="panelOpenState = true"
                                            (closed)="panelOpenState = false">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <ng-template #tipContent>
                                                        <div [innerHTML]="data.searchword"></div>
                                                    </ng-template>
                                                    <div class="blue" [ngbTooltip]="tipContent" container="body"
                                                        [innerHTML]="(data.searchword.length > 70)? (data.searchword | slice:0:70)+'...':(data.searchword)">
                                                    </div>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <hr class="mar-top-0">
                                            <p class="faq-ans">{{data.answers}}</p>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
            <div class="row mar-lft-rgt-0">
                <div class="col-sm-6 pad-15 text-center">
                    <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
                        (uploadError)="onFileError($event)" (complete)="onFileComplete($event)"
                        (onFileAttach)="onFileAttach()" (onFileRemove)="onRemove()" (dataLoaded)="onUpload($event)">
                    </app-material-fileupload>
                </div>
                <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
                </div>
            </div>
            <div class="row mar-lft-rgt-0">
                <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
                    <select class="custom-select" [(ngModel)]="impact">
                        <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
                    </select>
                </div>
                <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
                    <select class="custom-select" [(ngModel)]="urgency">
                        <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
                    </select>
                </div>
                <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
                    <select class="custom-select" [(ngModel)]="selectedPriority">
                        <option *ngFor="let priority of priorityArr" [value]="priority.id">{{priority.priority}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row mar-lft-rgt-0">
                <div class="col-sm-6 pad-15">
                    <button type="button" class="btn btn-success btn-block radius-0 font-13"
                        (click)="createTicket()">Create
                    </button>
                </div>
                <div class="col-sm-6 pad-15">
                    <button type="button" class="btn btn-success btn-block radius-0 font-13"
                        (click)="resetField()">Reset
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title">Asset management</h4>
        <button type="button" class="close" aria-label="Close" (click)="c()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group row">
            <div class="col-md-3">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected"
                    (change)="onMasterChange($event.target.selectedIndex)">
                    <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
                </select>
            </div>
            <div class="col-md-3">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="columnNameSelected"
                    (change)="onClientChange($event.target.selectedIndex)">
                    <option *ngFor="let column of columnDataObj" [value]="column.columnId">{{column.columnName}}
                    </option>
                </select>
            </div>
            <div class="col-md-3">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
                    placeholder="Digital Asset value">
            </div>
            <div class="col-md-3">
                <button type="button" class="btn btn-primary radius-0 font-13" (click)="submitAssetData()">Submit
                </button>
            </div>
        </div>
        <div class="overflow-auto">
            <angular-slickgrid gridId="grid1" [columnDefinitions]="columnDefinitions" [gridOptions]="gridOptions"
                (onAngularGridCreated)="angularGridReady($event)" gridWidth="4000" gridHeight="300"
                (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                [dataset]="data">
            </angular-slickgrid>
        </div>
    </div>
    <div class="modal-footer">
        <ngb-pagination [collectionSize]="collectionSize" [maxSize]="5" (pageChange)="onPageChange($event)"
            [(page)]="page" [pageSize]="pageSize" aria-label="Default pagination"></ngb-pagination>
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="saveData()" style="
    margin-top: 8px;">Add Asset ({{assetCount}})
        </button>
        <button type="button" class="btn btn-warning btn-block radius-0 font-13" (click)="c()">Save</button>
    </div>
</ng-template>


<ng-template #contentData let-modal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title">Search ticket to Attach</h4>
        <button type="button" class="close" aria-label="Close" (click)="c()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body  overY-hidden">
        <div class="shadow  ">
            <div class="row mar-lft-rgt-0">
                <input type="text" class="form-control font-13 col-sm-6 radius-0 mar-bot-10" [(ngModel)]="searchTid"
                    id="ticketId" placeholder="Enter Ticket Id">&nbsp;
                <button type="button" class="btn btn-primary font-13 radius-0 col-sm-2 mar-bot-10"
                    (click)="searchTicket()">Search
                    Ticket
                </button>
                <div class="height-40 col-sm-2 mar-bot-10" [hidden]="ticketIdSearchLoaded">
                    <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                </div>
            </div>
        </div>

        <span class="totalitem"><b>Total items: </b> {{totalItems}}</span>
        <div class="col-sm-12 height-250 mar-top-15">
            <angular-slickgrid gridId="grid2" [columnDefinitions]="ticketColumnDefinitions" [gridOptions]="gridOptions2"
                (onAngularGridCreated)="angularGridReady2($event)"
                (sgOnSelectedRowsChanged)="handleSelectedRowsChanged2($event.detail.eventData, $event.detail.args)"
                [dataset]="dataset">
            </angular-slickgrid>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-block radius-0 font-13   mar-top-9" (click)="addTicket()">Add
            Ticket ({{ticketCount}})
        </button>
        <button type="button" class="btn btn-danger btn-block radius-0 font-13 mar-top-9"
            (click)="saveReactiveProblemData()">Save
        </button>
    </div>
</ng-template>





<ng-template #groupSelect>
    <select class="custom-select radius-0 font-13" [(ngModel)]="userGroupSelected" (change)="onSelectGroup()">
        <option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</option>
    </select>
</ng-template>
<app-display-ticket-jusco *ngIf="!hideCr && !hidePr" [typeChecked]="radioChecked" [clientId]="clientId"
    [userGroupId]="userGroupId" [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="typeSeq"
    [inciId]="inciId" [isCreateTicket]="isCreateTicket"></app-display-ticket-jusco>

<app-display-ticket-cr *ngIf="hideCr" [typeChecked]="radioChecked" [clientId]="clientId" [userGroupId]="userGroupId"
    [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="typeSeq" [inciId]="inciId"
    [isCreateTicket]="isCreateTicket"></app-display-ticket-cr>

<app-display-ticket-pr *ngIf="hidePr" [typeChecked]="radioChecked" [clientId]="clientId" [userGroupId]="userGroupId"
    [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="typeSeq" [inciId]="inciId"
    [isCreateTicket]="isCreateTicket"></app-display-ticket-pr>
<notifier-container *ngIf="hideNotifier"></notifier-container>